import React, { useState, useCallback, useRef, useEffect, } from 'react';
import { noop, throttle } from 'lodash-es';
import BottomButton from './BottomButton';
import BottomContainer from './BottomContainer';
import BottomContent from './BottomContent';
const Bottom = ({ maxHeight, buttonStyle = 'Secondary', layerBackground, width = '100%', layerPadding = '1rem', showButtonText, hideButtonText, buttonWidth, children, }) => {
    const [isOverflow, setOverflow] = useState(false);
    const [isExpand, setExpand] = useState(false);
    const contentRef = useRef(null);
    const checkIsOverflowRef = useRef(noop);
    const contentMaxHeightRef = useRef(0);
    checkIsOverflowRef.current = () => {
        if (contentRef.current) {
            const { scrollHeight, clientHeight } = contentRef.current;
            const isContainerOverflow = isExpand && isOverflow
                ? scrollHeight > contentMaxHeightRef.current
                : scrollHeight > clientHeight;
            setOverflow(isContainerOverflow);
        }
    };
    const handleResize = useCallback(throttle(() => {
        checkIsOverflowRef.current();
    }, 200), []);
    useEffect(() => {
        checkIsOverflowRef.current();
    }, [maxHeight, isExpand, isOverflow, width]);
    useEffect(() => {
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [handleResize]);
    const toggleExpand = useCallback(() => {
        setExpand(prevState => {
            if (!prevState && contentRef.current) {
                contentMaxHeightRef.current = contentRef.current.clientHeight;
            }
            return !prevState;
        });
    }, []);
    return (React.createElement(BottomContainer, { width: width },
        React.createElement(BottomContent, { ref: contentRef, maxHeight: maxHeight, isExpand: isExpand, isOverflow: isOverflow }, children),
        isOverflow && (React.createElement(BottomButton, { isExpand: isExpand, onClick: toggleExpand, width: buttonWidth, layerPadding: layerPadding, buttonStyle: buttonStyle, layerBackground: layerBackground, showButtonText: showButtonText, hideButtonText: hideButtonText }))));
};
export default Bottom;
//# sourceMappingURL=Bottom.js.map